import { LOCALE_MAP } from "@/lib/constants";

/**
 * Format a numeric amount as currency for the given app language.
 * `lang` is an app language code ("en", "es", "pt"…); it's mapped to a full
 * locale via LOCALE_MAP (single source of truth in @/lib/constants).
 * Falls back to `"<CURRENCY> <number>"` if Intl rejects the currency code.
 */
export function formatCurrency(
  value: number,
  currency = "USD",
  lang = "en",
): string {
  const locale = LOCALE_MAP[lang] ?? lang;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${currency} ${value.toLocaleString()}`;
  }
}
